import React from 'react';
import { VideoInput } from 'components/common/Video/VideoInput';
import styles from './videoFormInput.module.scss';
import classNames from 'classnames/bind';
import { toast } from 'react-toastify';
import i18n from 'i18n';

export const VideoFormInput: React.FunctionComponent<any> = (props) => {
  const cssClassNames = classNames.bind(styles);

  const onFileChange = (file) => {
    if (!file) {
      props.onChange &&
        props.onChange({
          file: undefined,
          url: undefined
        });
      return;
    }
    const validTypes = ['video/mp4'];
    if (validTypes.indexOf(file.type) === -1) {
      props.onChange &&
        props.onChange({
          file,
          url: props.url
        });
      return;
    }
    // POS-7999：瀏覽器多半無法解碼 H.265，拿不到寬高/時長。outdoor 素材傳入
    // deferMetadataToServer，讓這種情況保留檔案、metadata 交由後端分析回填；
    // 其餘呼叫端維持原本「解碼失敗即擋下並清除」的行為。
    const deferToServer = () =>
      props.onChange &&
      props.onChange({
        file,
        width: undefined,
        height: undefined,
        duration: undefined,
        url: props.url
      });

    const video = document.createElement('video');
    video.addEventListener('loadedmetadata', () => {
      if (props.deferMetadataToServer && !video.videoWidth) {
        deferToServer();
        return;
      }
      props.onChange &&
        props.onChange({
          file,
          width: video.videoWidth,
          height: video.videoHeight,
          duration: video.duration,
          url: props.url
        });
    });
    video.addEventListener('error', () => {
      if (props.deferMetadataToServer) {
        deferToServer();
        return;
      }
      // ECOPD-5471: 這是「瀏覽器無法解碼影片」的通用錯誤（涵蓋 av1/H.265/H.264），
      // 屬前端解碼能力問題，非依渠道白名單的封鎖訊息，因此刻意保持通用、不做 per-channel。
      // 渠道允許編碼的封鎖訊息由後端 400076（serverResponse.400076）負責呈現。
      toast.error(i18n.t('videoFormInput.errors.loadingVideo'));
      props.onChange &&
        props.onChange({
          file: undefined,
          url: undefined
        });
    });
    video.src = URL.createObjectURL(file);
  };
  const mainClassdName = cssClassNames('videoPreview', props.className, {
    showErrorBorder: props.errorBorderHint,
    showSolidBorder: props.url || props.file
  });
  return (
    <div className={mainClassdName}>
      <div className={styles.videoContent}>
        <VideoInput {...props} onChange={onFileChange} />
      </div>
    </div>
  );
};
